import { Link } from 'react-router-dom'
import SEO from '../components/SEO'
import PageHero from '../components/PageHero'
import SectionHeading from '../components/SectionHeading'
import VideoSection from '../components/VideoSection'
import ScrollReveal from '../components/ScrollReveal'
import SocialIcons from '../components/SocialIcons'
import CTASection from '../components/CTASection'
import { socials } from '../data/siteData'
import './Videos.css'

export default function Videos() {
  return (
    <>
      <SEO
        title="Videos & Shorts | Event Highlights — AS Elite Gatherings"
        description="Watch wedding highlights, corporate event reels, product launch reveals and stage decoration time-lapses from AS Elite Gatherings, Marthandam."
        keywords="event highlight videos Marthandam, wedding videos Tamil Nadu, corporate event reels, event management video gallery"
        path="/videos"
      />
      <PageHero
        eyebrow="Watch"
        title="Videos & Shorts"
        text={
          <>
            Event highlights, reveal moments and behind-the-scenes reels from AS Elite
            Gatherings — straight from our YouTube, Instagram and Facebook. See the full
            story in our <Link to="/gallery">photo gallery</Link> or read more{' '}
            <Link to="/about">about our studio</Link>.
          </>
        }
        image="/images/bg/bg7.webp"
      />

      <section className="section">
        <div className="container">
          <SectionHeading
            eyebrow="On YouTube"
            title="Highlights & Shorts"
            text="Subscribe to catch full event walkthroughs, award nights and cultural shows as we post them."
          />
          <VideoSection />
        </div>
      </section>

      <section className="section section-alt">
        <div className="container follow-panel">
          <ScrollReveal className="follow-panel-card">
            <span className="follow-panel-icon" aria-hidden="true">▶</span>
            <h3>YouTube</h3>
            <p>Full event highlights, award ceremonies, cultural programs and talent showcases.</p>
            <a href={socials.youtube} target="_blank" rel="noreferrer" className="btn btn-ghost">
              @aselitegathering
            </a>
          </ScrollReveal>
          <ScrollReveal delay={100} className="follow-panel-card">
            <span className="follow-panel-icon" aria-hidden="true">◎</span>
            <h3>Instagram</h3>
            <p>Reels from setup to strike — decor detail shots and reveal moments as they happen.</p>
            <a href={socials.instagram} target="_blank" rel="noreferrer" className="btn btn-ghost">
              @aselite_gatherings
            </a>
          </ScrollReveal>
          <ScrollReveal delay={200} className="follow-panel-card">
            <span className="follow-panel-icon" aria-hidden="true">f</span>
            <h3>Facebook</h3>
            <p>Event albums, client stories and updates from AS Elite Gatherings, Marthandam.</p>
            <a href={socials.facebook} target="_blank" rel="noreferrer" className="btn btn-ghost">
              AS Elite Gatherings
            </a>
          </ScrollReveal>
        </div>
        <div className="container" style={{ display: 'flex', justifyContent: 'center', marginTop: 40 }}>
          <SocialIcons variant="inline" />
        </div>
      </section>

      <CTASection />
    </>
  )
}
